<template>
  <div class="uk-container">
    <appointment-info :appointment-id="appointmentId">
      <template v-slot:header>
        <p data-cy="message">Appointment was created successfully, the card was charged successfully and notifications were processed.</p>
      </template>

      <template v-slot:bodyEnd>
        <div class="uk-margin">Notifications processed!</div>

        <div class="uk-margin">
          <div>
            Dentist Email:
            <b v-if="notifications.dentist.email.requested">Requested</b>
            <b v-else>Not Requested</b>
            and
            <b v-if="notifications.dentist.email.status">Sent</b>
            <b v-else>Not Sent</b>
          </div>
          <div>
            Dentist SMS:
            <b v-if="notifications.dentist.phone.requested">Requested</b>
            <b v-else>Not Requested</b>
            and
            <b v-if="notifications.dentist.phone.status === 'accepted'">Sent</b>
            <b v-else-if="notifications.dentist.phone.status === false">Not Sent</b>
            <b v-else>Error</b>
          </div>
        </div>

        <div class="uk-margin">
          <div>
            Customer Email:
            <b v-if="notifications.customer.email.requested">Requested</b>
            <b v-else>Not Requested</b>
            and
            <b v-if="notifications.customer.email.status">Sent</b>
            <b v-else>Not Sent</b>
          </div>
          <div>
            Customer SMS:
            <b v-if="notifications.customer.phone.requested">Requested</b>
            <b v-else>Not Requested</b>
            and
            <b v-if="notifications.customer.phone.status === 'accepted'">Sent</b>
            <b v-else-if="notifications.customer.phone.status === false">Not Sent</b>
            <b v-else>Error</b>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button class="uk-button uk-button-primary" @click="restart">Book a new appointment</button>
      </template>
    </appointment-info>
  </div>
</template>

<script>
import AppointmentInfo from '@/components/appointment/Info.vue'

export default {
  name: 'ComponentAppointmentResult',

  components: { AppointmentInfo },

  props: {
    appointmentId: {
      type: String,
      required: true
    }
  },

  computed: {
    appointment() {
      return this.appointmentId ? this.$store.getters['appointments/find'](this.appointmentId) : null
    },

    dentist() {
      return this.$store.getters['dentists/find'](this.appointment.dentist.id) || null
    },

    notifications() {
      return this.appointment.log.find((log) => log.type === 'notification' && log.subtype === 'create').content
    }
  },

  methods: {
    formatDate(date, special = false) {
      let response = null

      if (special) {
        const timestamp = `${date.d} ${this.$helpers.timeBits.find((b) => b.id === date.b).time.short}`
        response = this.$moment(timestamp, 'YYMMDD HH:mm').fromNow()
      } else {
        response = this.$moment(date, 'X').fromNow()
      }

      return response
    },

    restart() {
      this.$bus.$emit('appointment-restart')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  .section {
    .section-title {
      padding: 6px;
      background-color: $colour-primary;
      color: $colour-light;
    }

    .section-content {
      .item {
        display: flex;

        &:not(:last-of-type) {
          border-bottom: 1px solid $colour-grey;
        }

        .item-title {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          justify-content: center;
          width: 100px;
          padding: 8px 6px;
          border-right: 1px solid $colour-grey;
          font-weight: 500;
        }

        .item-content {
          width: 100%;
          padding: 8px 12px;
          text-align: left;

          .composite {
            display: flex;

            .composite-part {
              text-align: center;

              &:not(:last-of-type) {
                margin-right: 8px;
              }

              // .value {}

              .label {
                font-size: .7em;
              }
            }

            &.composite-spaced {
              justify-content: space-between;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
